export const CA_SAVE_CA_BEGIN = 'CA_SAVE_CA_BEGIN';
export const CA_SAVE_CA_SUCCESS = 'CA_SAVE_CA_SUCCESS';
export const CA_SAVE_CA_FAILURE = 'CA_SAVE_CA_FAILURE';
export const CA_SAVE_CA_DISMISS_ERROR = 'CA_SAVE_CA_DISMISS_ERROR';
export const CA_DELETE_CA_BEGIN = 'CA_DELETE_CA_BEGIN';
export const CA_DELETE_CA_SUCCESS = 'CA_DELETE_CA_SUCCESS';
export const CA_DELETE_CA_FAILURE = 'CA_DELETE_CA_FAILURE';
export const CA_DELETE_CA_DISMISS_ERROR = 'CA_DELETE_CA_DISMISS_ERROR';
export const CA_FETCH_DELIVERABLES_AVAILABLE_BEGIN = 'CA_FETCH_DELIVERABLES_AVAILABLE_BEGIN';
export const CA_FETCH_DELIVERABLES_AVAILABLE_SUCCESS = 'CA_FETCH_DELIVERABLES_AVAILABLE_SUCCESS';
export const CA_FETCH_DELIVERABLES_AVAILABLE_FAILURE = 'CA_FETCH_DELIVERABLES_AVAILABLE_FAILURE';
export const CA_FETCH_DELIVERABLES_AVAILABLE_DISMISS_ERROR = 'CA_FETCH_DELIVERABLES_AVAILABLE_DISMISS_ERROR';
export const CA_SAVE_DELIVERABLE_ASSIGNATION_BEGIN = 'CA_SAVE_DELIVERABLE_ASSIGNATION_BEGIN';
export const CA_SAVE_DELIVERABLE_ASSIGNATION_SUCCESS = 'CA_SAVE_DELIVERABLE_ASSIGNATION_SUCCESS';
export const CA_SAVE_DELIVERABLE_ASSIGNATION_FAILURE = 'CA_SAVE_DELIVERABLE_ASSIGNATION_FAILURE';
export const CA_SAVE_DELIVERABLE_ASSIGNATION_DISMISS_ERROR = 'CA_SAVE_DELIVERABLE_ASSIGNATION_DISMISS_ERROR';
export const CA_DELETE_ASSIGNATION_BEGIN = 'CA_DELETE_ASSIGNATION_BEGIN';
export const CA_DELETE_ASSIGNATION_SUCCESS = 'CA_DELETE_ASSIGNATION_SUCCESS';
export const CA_DELETE_ASSIGNATION_FAILURE = 'CA_DELETE_ASSIGNATION_FAILURE';
export const CA_DELETE_ASSIGNATION_DISMISS_ERROR = 'CA_DELETE_ASSIGNATION_DISMISS_ERROR';
export const CA_OPEN_COST_MODEL = 'CA_OPEN_COST_MODEL';
export const CA_CLOSE_COST_MODEL = 'CA_CLOSE_COST_MODEL';
export const CA_FETCH_COST_BY_CONTROL_ACCOUNT_BEGIN = 'CA_FETCH_COST_BY_CONTROL_ACCOUNT_BEGIN';
export const CA_FETCH_COST_BY_CONTROL_ACCOUNT_SUCCESS = 'CA_FETCH_COST_BY_CONTROL_ACCOUNT_SUCCESS';
export const CA_FETCH_COST_BY_CONTROL_ACCOUNT_FAILURE = 'CA_FETCH_COST_BY_CONTROL_ACCOUNT_FAILURE';
export const CA_FETCH_COST_BY_CONTROL_ACCOUNT_DISMISS_ERROR = 'CA_FETCH_COST_BY_CONTROL_ACCOUNT_DISMISS_ERROR';
export const CA_SAVE_COST_BEGIN = 'CA_SAVE_COST_BEGIN';
export const CA_SAVE_COST_SUCCESS = 'CA_SAVE_COST_SUCCESS';
export const CA_SAVE_COST_FAILURE = 'CA_SAVE_COST_FAILURE';
export const CA_SAVE_COST_DISMISS_ERROR = 'CA_SAVE_COST_DISMISS_ERROR';
export const CA_CLOSE_SNACK_BAR = 'CA_CLOSE_SNACK_BAR';
export const CA_SAVE_COST_DETAIL_BEGIN = 'CA_SAVE_COST_DETAIL_BEGIN';
export const CA_SAVE_COST_DETAIL_SUCCESS = 'CA_SAVE_COST_DETAIL_SUCCESS';
export const CA_SAVE_COST_DETAIL_FAILURE = 'CA_SAVE_COST_DETAIL_FAILURE';
export const CA_SAVE_COST_DETAIL_DISMISS_ERROR = 'CA_SAVE_COST_DETAIL_DISMISS_ERROR';
export const CA_OPEN_REVIEW_COST_MODEL = 'CA_OPEN_REVIEW_COST_MODEL';
export const CA_CLOSE_REVIEW_COST_MODEL = 'CA_CLOSE_REVIEW_COST_MODEL';



// WEBPACK FOOTER //
// ./src/features/ca/redux/constants.js